import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { MobileService }                       from './mobile.service';
import { MobileStates }                        from './mobile.states';
import { MobileVideoMinutesPurchaseComponent } from './mobile.video-minutes-purchase.component';
import { MobileVideoSettingsComponent }        from './mobile.video-settings.component';
import { SharedModule }                        from '../shared/shared.module';

@NgModule({
  declarations: [
    MobileVideoMinutesPurchaseComponent,
    MobileVideoSettingsComponent
  ],
  entryComponents: [
    MobileVideoMinutesPurchaseComponent,
    MobileVideoSettingsComponent
  ],
  imports: [
    SharedModule,

    UIRouterUpgradeModule.forChild({ states: MobileStates })
  ],
  providers: [
    MobileService
  ]
})
export class MobileModule {}
